import { LegalLayout, LegalSection } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function RefundPolicyPage() {
  return (
    <LegalLayout
      eyebrow="Policies"
      title="Refund Policy"
      description={`Our commitment to fair, transparent handling of overpayments and cancellations at ${siteConfig.companyName}.`}
    >
      <LegalSection>
        <p>
          {siteConfig.companyName} is committed to ensuring that any
          amounts owed back to a customer are refunded promptly and
          transparently. This Refund Policy explains the circumstances
          under which a refund may apply and how it will be processed.
        </p>
      </LegalSection>

      <LegalSection heading="When a Refund May Apply">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <span className="font-semibold text-[#1c1917]">
              Pre-disbursement cancellation:
            </span>{" "}
            If a loan has been sanctioned but not yet disbursed, and the
            applicant chooses to cancel, no repayment is owed and any
            application-stage charges collected will be refunded in full.
          </li>
          <li>
            <span className="font-semibold text-[#1c1917]">
              Excess or duplicate payments:
            </span>{" "}
            If a customer's account reflects a payment made in excess of
            the outstanding amount, or a payment processed more than once
            due to a technical error, the excess amount is refundable.
          </li>
          <li>
            <span className="font-semibold text-[#1c1917]">
              Failed or incomplete transactions:
            </span>{" "}
            If an amount is debited from a customer's bank account but the
            corresponding loan repayment or fee payment is not
            successfully reflected on the platform, the amount will be
            refunded once the transaction is reconciled.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Refund Timeline">
        <p>
          Eligible refunds are processed within 5–7 business days from the
          date the underlying payment is reconciled. Refunds are credited
          to the same bank account or payment method originally used for
          the transaction, unless otherwise agreed with the customer.
        </p>
      </LegalSection>

      <LegalSection heading="Non-Refundable Items">
        <p>
          Interest accrued and charges applicable up to the date of a valid
          cancellation or repayment are not refundable. Once a loan has
          been disbursed, the principal amount and any applicable interest
          for the period the funds were held remain payable by the
          customer in accordance with the loan agreement.
        </p>
      </LegalSection>

      <LegalSection heading="How to Request a Refund">
        <p>
          To request a refund or report a payment discrepancy, please
          contact our support team
          {siteConfig.email ? (
            <>
              {" "}
              at{" "}
              <a
                href={`mailto:${siteConfig.supportEmail || siteConfig.email}`}
                className="font-semibold text-brand-purple underline"
              >
                {siteConfig.supportEmail || siteConfig.email}
              </a>
            </>
          ) : null}
          {siteConfig.phoneDisplay ? ` or call ${siteConfig.phoneDisplay}` : ""}
          , quoting your loan account number or transaction reference. We
          aim to acknowledge every refund request within 24 hours.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
